import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as packageRateService from '../services/packageRateService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import { getListPackageRates, setListPackageRates, setPackageRateDetail, getPackageRateDetail, setPackageRateTranslate, setPackageRateProduct, setPackageRateTab, setCreatePackageRate } from '../actions/packageRateAction';
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { omit } from 'lodash';
import history from '../helpers/history';

function* getListPackageRateSaga() {
    yield takeLatest(Types.PACKAGE_RATE_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const limit = action.filters.pageSize ? action.filters.pageSize : undefined;
        const offset = action.filters.pageIndex ? (action.filters.pageIndex - 1) * limit : undefined;
        const params = {
            ...omit(action.filters, ['pageIndex', 'pageSize']),
            limit, offset,
        }
        const result = yield call(packageRateService.getPackageRateList, params);
        yield put(setListPackageRates(result));
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* updatePackageRateActive() {
    yield takeLatest(Types.PACKAGE_RATE_UPDATE_ACTIVE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(packageRateService.updatePackageRateActive, action.id, action.data);
        yield put(getListPackageRates(action.filters));
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.packageRate.title')} "${action.data.name}"` })
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* deletePackageRate() {
    yield takeLatest(Types.PACKAGE_RATE_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(packageRateService.deletePackageRate, action.id);
        yield put(getListPackageRates(action.filters));
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}` })
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* clonePackageRate() {
    yield takeLatest(Types.PACKAGE_RATE_CLONE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(packageRateService.clonePackageRate, action.id);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.cloneSuccess')}` })
        history.push(Func.getPathWithParams(PATHS.PACKAGE_RATE.DETAIL.path, { id: result.data.data }));
        history.go();
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* getPackageRateDetailData() {
    yield takeLatest(Types.PACKAGE_RATE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(packageRateService.getPackageRateDetail, action.id);
        yield put(setPackageRateDetail(result));
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* updatePackageRate() {
    yield takeLatest(Types.PACKAGE_RATE_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        yield call(packageRateService.updatePackageRate, action.data, action.id);
        yield put(getPackageRateDetail(action.id));
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.packageRate.title')} "${action.data.name}"` })
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* createPackageRate() {
    yield takeLatest(Types.PACKAGE_RATE_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(packageRateService.createPackageRate, action.data);
        yield put(setCreatePackageRate());
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.packageRate.title')} "${action.data.name}"` })
        history.push(Func.getPathWithParams(PATHS.PACKAGE_RATE.DETAIL.path, { id: result.data.data }, "detail"));
        history.go();
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* updatePackageRateTranslate() {
    yield takeLatest(Types.PACKAGE_RATE_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        yield call(packageRateService.updatePackageRateTranslate, {...action.data, packageRateId: action.id });
        yield put({ type: Types.PACKAGE_RATE_GET_TRANSLATE_ACTION, id: action.id });
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.packageRate.title')} "${action.data.name}"` })
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* createPackageRateTranslate() {
    yield takeLatest(Types.PACKAGE_RATE_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        yield call(packageRateService.createPackageRateTranslate, {...action.data, packageRateId: action.id });
        yield put({ type: Types.PACKAGE_RATE_GET_TRANSLATE_ACTION, id: action.id });
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.packageRate.title')} "${action.data.name}"` })
        yield put(setPackageRateTab(3));
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* getPackageRateTranslate() {
    yield takeLatest(Types.PACKAGE_RATE_GET_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(packageRateService.getPackageRatteTranslate, action.id);
        yield put(setPackageRateTranslate(result));
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* createPackageRateProduct() {
    yield takeLatest(Types.PACKAGE_RATE_CREATE_PRODUCT_ACTION, Func.sagaWrapper(function* (action) {
        yield call(packageRateService.createPackageRateProduct, action.id, action.data);
        yield put({ type: Types.PACKAGE_RATE_GET_PRODUCT_ACTION, id: action.id });
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.packageRate.title')} "${action.data.name}"` })
        history.push(PATHS.PACKAGE_RATE.LIST.path);
        history.go();
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* updatePackageRateProduct() {
    yield takeLatest(Types.PACKAGE_RATE_UPDATE_PRODUCT_ACTION, Func.sagaWrapper(function* (action) {
        yield call(packageRateService.updatePackageRateProduct, action.id, action.data);
        yield put({ type: Types.PACKAGE_RATE_GET_PRODUCT_ACTION, id: action.id });
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.packageRate.title')} "${action.data.name}"` })
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function* getPackageRateProduct() {
    yield takeLatest(Types.PACKAGE_RATE_GET_PRODUCT_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(packageRateService.getPackageRateProduct, action.id);
        yield put(setPackageRateProduct(result));
    }, errorHandleRate(Types.PACKAGE_RATE_FAIL)))
}

function errorHandleRate(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'package-rate');
}

export function* packageRateSaga() {
    yield all([
        fork(getListPackageRateSaga),
        fork(getPackageRateDetailData),
        fork(updatePackageRate),
        fork(updatePackageRateActive),
        fork(deletePackageRate),
        fork(clonePackageRate),
        fork(createPackageRate),
        fork(updatePackageRateTranslate),
        fork(createPackageRateTranslate),
        fork(getPackageRateTranslate),
        fork(createPackageRateProduct),
        fork(updatePackageRateProduct),
        fork(getPackageRateProduct),
    ])
}
